module.exports = __webpack_public_path__ + "static/media/menu_cascade.d038dc44.svg";